// Dashboard - primary page with analytics
import DashboardPage from "../views/Dashboard/Dashboard.jsx";
// General - Appearance page - change in-app colors
import GeneralView from '../views/General/general.jsx';
// User Profile page
import UserProfile from "../views/Users/UserProfile.jsx";
// list of all (pertinent) Users
import UserList from "../views/Users/UserList.jsx";
// list of all (pertinent) Admins
import AdminList from "../views/Users/AdminList.jsx";
// view, add, and remove Events
import EventsView from "../views/Events/events.jsx";
// view, add, and remove Friends
import FriendsList from "../views/Friends/friends.jsx";
// view, add, and remove Rewards
import RewardsView from "../views/Rewards/rewards.jsx";
// view, add, and remove News
import NewsList from "../views/Newsletter/newsletters.jsx";
// send and schedule Notifications
import NotificationsPage from "../views/Notifications/Notifications.jsx";
// create Page Buttons (Articles, Links, Shortcuts)
import Moose from "../views/Moose/moose.jsx";
// create, add, and remove Sports News
import SportsNews from "../views/SportsNews/sportsNews.jsx";
// create, add, and remove Seasons, Schedules, Rosters
import Season from "../views/Season/season.jsx";
// add references to side databases (only for Master app Main branches)
import Shards from "../views/Shards/shards.jsx";
// create, edit, and remove Lotteries metadata pertaining to central backend
import Lotto from "../views/Lotto/lotto.jsx";
// create, add, and remove Coupons from Loyalty screen
import Coupons from "../views/Coupons/coupons.jsx";
// create and edit Locations from Location screen
import Locations from "../views/Locations/locations.jsx";
// Automation - enable automatically grabbing data from APIs
import Automation from "../views/Automation/automation.jsx";
// Home - rearrange Home screen and manage App Settings
import Rearrange from "../views/Home/Home.jsx";

// To remove any of these from the backend
// (and consequently, the frontend as well)
// simply comment out their imports above
// and their corresponding object below

import {
  Dashboard,
  Event,
  Person,
  VerifiedUser,
  Group,
  Notifications,
  CardGiftcard,
  FiberNew,
  FormatColorFill,
  Settings,
  DonutSmall,
  Games,
  ChromeReaderMode,
  Receipt,
  LocationSearching,
  Gradient,
  Backup,
  Build,
} from "@material-ui/icons";

const appRoutes = [
  /* Main Dashboard */
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Administrator Dashboard",
    icon: Dashboard,
    component: DashboardPage
  },
  /* Appearance */
  {
    id: 'appearance',
    path: "/general",
    sidebarName: "Appearance",
    navbarName: "Appearance",
    icon: FormatColorFill,
    component: GeneralView
  },
  /* Users */
  {
    id: 'users',
    path: "/users",
    sidebarName: "Users",
    navbarName: "Users",
    icon: Person,
    component: UserList
  },
  /* Administrators  */
  {
    id: 'admins',
    path: "/admins",
    sidebarName: "Admins",
    navbarName: "Admins",
    icon: VerifiedUser,
    component: AdminList
  },
  /* Announcements */
  {
    id: 'notifications',
    path: "/notifications",
    sidebarName: "Notifications",
    navbarName: "Notifications",
    icon: Notifications,
    component: NotificationsPage
  },
  /* What's Happening */
  {
    id: 'events',
    path: "/events",
    sidebarName: "Events",
    navbarName: "Events",
    icon: Event,
    component: EventsView
  },
  /* News */
  {
    id: 'newsletters',
    path: "/news",
    sidebarName: "Newsletters",
    navbarName: "Newsletters",
    icon: FiberNew,
    component: NewsList
  },
  /* Sports News */
  {
    id: 'sportsNews',
    path: "/sportsnews",
    sidebarName: "Sports News",
    navbarName: "Sports News",
    icon: DonutSmall,
    component: SportsNews,
  },
  /* Sports Roster/Schedule */
  {
    id: 'season',
    path: "/season",
    sidebarName: "Schedule/Roster",
    navbarName: "Schedule/Roster",
    icon: Games,
    component: Season,
  },
  /* Community */
  {
    id: 'friends',
    path: "/friends",
    sidebarName: "Friends",
    navbarName: "Friends",
    icon: Group,
    component: FriendsList
  },
  /* Rewards/Loyalty Program */
  {
    id: 'rewards',
    path: "/rewards",
    sidebarName: "Rewards",
    navbarName: "Rewards",
    icon: CardGiftcard,
    component: RewardsView
  },
  /* Customization */
  {
    id: 'customize',
    path: "/customize",
    sidebarName: "Customize",
    navbarName: "Customize",
    icon: Settings,
    component: Moose
  },
  /* Databases */
  {
    id: "schools",
    path: "/schools",
    sidebarName: "Schools",
    navbarName: "Schools",
    icon: Gradient,
    component: Shards
  },
  /* Databases */
  {
    id: "settings",
    path: "/settings",
    sidebarName: "Settings",
    navbarName: "Settings",
    icon: Build,
    component: Rearrange
  },
  {
    id: "lotto",
    path: "/lotto",
    sidebarName: "Lottery",
    navbarName: "Lottery",
    icon: Receipt,
    component: Lotto
  },
  {
    id: "coupons",
    path: "/coupons",
    sidebarName: "Coupons",
    navbarName: "Coupons",
    icon: ChromeReaderMode,
    component: Coupons
  },
  {
    id: "locations",
    path: "/locations",
    sidebarName: "Locations",
    navbarName: "Locations",
    icon: LocationSearching,
    component: Locations
  },
  {
    id: "automation",
    path: "/automation",
    sidebarName: "Automation",
    navbarName: "Automation",
    icon: Backup,
    component: Automation
  },
  {
    sidebar: 'no',
    path: "/users/:userId",
    component: UserProfile
  }
];

export default appRoutes;
